<template>
  <div>
    <a-row>
      <g-master name="project_person"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                modalWidth="80%"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup endpoint="usuarios"
                        :formItemConfig="fiOptions"
                        :label="$t('Usuario asignado en el sistema')"
                        :cache="false"
                        :decorator="['user_name', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                        ref="user"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Nombre Completo')">
                <a-input class="ant-uppercase"
                  v-decorator="['full_name', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Correo')">
                <a-input
                  v-decorator="['email', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Numero telefonico de contacto')">
                <a-input
                  v-decorator="['cell_phone_number', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Rol en el proyecto')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_role_project', { rules: [{ required: false }] }]"
                          :params="rol_proyecto">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        rol_proyecto: {
          h_lookup_type: 'GP_ROLES_PROYECTO'
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'project_personas',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre Completo', dataIndex: 'full_name', sorter: true},
              {title: 'Nombre de usuario en el sistema', dataIndex: 'user_name', sorter: true},
              {title: 'Correo', dataIndex: 'email', sorter: true},
              {title: 'Numero de contacto', dataIndex: 'cell_phone_number', sorter: true},
              {title: 'Rol en el proyecto', dataIndex: 'rol', sorter: true}
            ]
          }
        }
      }
    },
    props: ['project_id'],
    computed: {
      parentData () {
        return {
          project_id: this.project_id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GestionDeProyectos/ProjectPersonas.vue